<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    tag?: string | Component;
    padless?: boolean;
  }>(),
  { tag: "button" }
);
</script>

<template>
  <component
    :is="props.tag"
    :class="[
      'page-header-button',
      'h-10',
      'flex items-center justify-center gap-2',
      'text-sm leading-[0.625rem] font-semibold',
      'whitespace-nowrap',
      {
        'page-header-button--padless p-0': props.padless,
        'px-3 lg:px-4': !props.padless,
      },
    ]"
  >
    <slot v-bind="{ props }"></slot>
  </component>
</template>
